import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Injectable({ providedIn: 'root' })
export class MyApplicationsService {
  constructor(private readonly http: HttpClient,
    private readonly httpservice: HttpService
  ) { }

  getAllApplications(): Observable<any[]> {
    // Adjust the URL if your backend is on a different base path
    return this.http.post<any[]>('/api/application/all', {});
  }

  getLookupData(): Observable<any[]> {
    // Adjust the URL to your actual lookup API endpoint
    return this.http.get<any[]>('/api/lookup', { params: { requestType: 'APPLICATION_TYPES' } });
    // If it's a POST, use: return this.http.post<any[]>('/api/lookup', {});
  }
  getPerson(userid: any, application_id?: any): Observable<any> {
    let url = `/application-flow/person?userId=${userid}`;
    if (application_id) {
      url += `&application_id=${application_id}`;
    }
    return this.httpservice.get(url);
  }
    getApplication(application_id: any): Observable<any> {
    return this.httpservice.get(`/application-flow/person?application_id=${application_id}`);
  }
  getAppData(personId: any): Observable<any> {
    return this.httpservice.get(`${API_ENDPOINTS.appData}?${personId}`);
  }
  createApplication(request: any): Observable<any> {
    return this.httpservice.post('/application-flow/application', request);
  }
  licenseKind(request: any): Observable<any> {
    return this.httpservice.post('/application-flow/license-kind', request);
  }
  createApplicationTimeline(request: any): Observable<any> {
    return this.httpservice.post('/application-flow/applicationTimeline', request);
  }
  updateApplicationStatus(request: any): Observable<any> {
    return this.httpservice.post('/application-flow/updateApplicationStatus', request);
  }
  uploadDocumentLog(auditLogData: any): Observable<any> {
    return this.httpservice.post('/application-flow/document-upload-audit-log', auditLogData);
  }
  getCommunicationData(applicationId: number): Observable<any>{
    return this.httpservice.get(`${API_ENDPOINTS.communicationData}/${applicationId}`);
  }
  getBusinessRules(){
    return this.httpservice.get(API_ENDPOINTS.fetchBusinessRules);
  }
  setupResolveApplication(userId: number): Observable<any> {
    return this.httpservice.post('/application-flow/setup-resolve-application', { userId });
  }
  setupEndroseeApplication(userId: number): Observable<any> {
    return this.httpservice.post('/application-flow/setup-licenseendrose-application', { userId });
  }
  unArchiveApplication(payload:any){
    return this.httpservice.patch('/queues/unarchive-application',payload);
  }
}